export type DeadlineFormLessonDefault = {
  dueAt: string | null;
  allowLate: boolean;
};

export type DeadlineFormOverride = {
  dueAt: string | null;
  allowLate: boolean;
};

/** Hydrate the builder form: override wins; otherwise lesson defaults (no-row fallthrough). */
export function resolveDeadlineFormState(input: {
  lessonDefault: DeadlineFormLessonDefault;
  override: DeadlineFormOverride | null | undefined;
}): {
  dueAt: string | null;
  allowLate: boolean;
  hasOverride: boolean;
  clearDue: boolean;
} {
  if (!input.override) {
    return {
      dueAt: input.lessonDefault.dueAt,
      allowLate: input.lessonDefault.allowLate,
      hasOverride: false,
      clearDue: false,
    };
  }
  return {
    dueAt: input.override.dueAt,
    allowLate: input.override.allowLate,
    hasOverride: true,
    clearDue: input.override.dueAt == null,
  };
}
